const asList = (value) => (Array.isArray(value) ? value : []);

const userHasRole = (user, requestedRoles = []) => {
  if (!user) return false;

  const roles = asList(user.role);
  return (
    roles.includes("super-admin") ||
    requestedRoles.some((role) => roles.includes(role))
  );
};

const userHasPermission = (user, requestedPermissions = []) => {
  if (!user) return false;

  const roles = asList(user.role);
  const permissions = [
    ...asList(user.permissions),
    ...asList(user.permissions_all),
  ];
  return (
    roles.includes("super-admin") ||
    requestedPermissions.some((permission) => permissions.includes(permission))
  );
};

const userLogoClubPath = (user) => {
  const path = user && user.logo_club && user.logo_club.path;

  return typeof path === "string" && path.length ? path : null;
};

const sessionLoadFailure = (error) => {
  const status = error && error.response && error.response.status;

  return status === 401 || status === 403 ? "denied" : "unavailable";
};

module.exports = {
  sessionLoadFailure,
  userHasRole,
  userHasPermission,
  userLogoClubPath,
};
